module.exports = "<h1>{{title}}</h1>\n<p>{{counter}}</p>\n"